import { configureStore } from '@reduxjs/toolkit';
// import { setupListeners } from '@reduxjs/toolkit/query';

import { accountPasswordSlice, accountCredentialsSlice, signUpSlice, accountReadSlice, accountUpdateSlice, usersSlice, userCreateSlice, userUpdateSlice, userDeleteSlice, userReadSlice, userPasswordUpdateSlice, userPasswordReadSlice, accountPhoneNumberReadSlice, accountPhoneNumberUpdateSlice, accountPhoneNumberUpdateConfirmSlice, accountEmailReadSlice, accountEmailUpdateSlice, accountEmailUpdateConfirmSlice, userPhoneNumberUpdateSlice, userPhoneNumberReadSlice, userEmailReadSlice, userEmailUpdateSlice, userEmailDeleteSlice, userRolesReadSlice, accountPassportUpdateSlice, accountPassportReadSlice, usersTypesSlice, userTypeCreateSlice, userTypeReadSlice, userTypeUpdateSlice, userTypeDeleteSlice, userTypeRolesUpdateSlice, userTypeRolesReadSlice, userPassportReadSlice, userPassportUpdateSlice, userClientListSlice, userClientCreateSlice, userClientReadSlice, userClientUpdateSlice, userClientDeleteSlice, userClientContactListSlice, userClientContactCreateSlice, userClientContactReadSlice, userClientContactUpdateSlice, userClientContactDeleteSlice, usersMetaSlice, recoverySlice, userPhoneNumberDeleteSlice, userTypeHistoryUpdateSlice, userTypeHistoryReadSlice, usersTypeHistoriesSlice, signOutSlice, signInSlice, sourceAccountClientSlice, userCardReadSlice, accountCardReadSlice, accountTypeChangesSlice, accountTypeChangeReadSlice, systemSettingsSlice, systemSettingReadSlice, systemSettingUpdateSlice, systemSettingTypesSlice, systemSettingTypeReadSlice, systemSettingTypeUpdateSlice, systemSettingUsersSlice, systemSettingShiftSlice, systemSettingReportSlice, systemSettingBookkeepingSlice, systemSettingBookkeepingBillChangesConstraintReadSlice, systemSettingBookkeepingBillChangesConstraintUpdateSlice, systemSettingCalendarSlice, systemSettingAmocrmSlice, systemSettingAmocrmClientIdReadSlice, systemSettingAmocrmClientIdUpdateSlice, systemSettingAmocrmClientSecretReadSlice, systemSettingAmocrmClientSecretUpdateSlice, systemSettingBookkeepingWorkDayHoursCountReadSlice, systemSettingBookkeepingWorkDayHoursCountUpdateSlice, systemSettingUsersAccountUserTypeReadSlice, systemSettingUsersAccountUserTypeUpdateSlice, sourceSystemSettingCalendarEventColorsSlice, systemSettingCalendarEventColorBirthdayReadSlice, systemSettingCalendarEventColorBirthdayUpdateSlice, systemSettingCalendarEventColorProjectReadSlice, systemSettingCalendarEventColorProjectUpdateSlice, systemSettingReportsPhotoNotAttachingPenaltyReadSlice, systemSettingReportsPhotoNotAttachingPenaltyUpdateSlice, systemSettingReportsWritingDelayPenaltyReadSlice, systemSettingReportsWritingDelayPenaltyUpdateSlice, systemSettingShiftsIsNoticeUsersByShiftChangesReadSlice, systemSettingShiftsIsNoticeUsersByShiftChangesUpdateSlice, systemSettingShiftsNotCountingOverworkTimeReadSlice, systemSettingShiftsNotCountingOverworkTimeUpdateSlice, applicationListSlice, applicationCreateSlice, applicationReadSlice, applicationUpdateSlice, applicationDeleteSlice, brandListSlice, brandCreateSlice, brandReadSlice, brandUpdateSlice, brandDeleteSlice, providerListSlice, providerCreateSlice, providerReadSlice, providerUpdateSlice, providerDeleteSlice, sourceProviderSlice, sourceBrandSlice, providerBrandListSlice, providerBrandReadSlice, providerBrandUpdateSlice, providerUserListSlice, providerUserCreateSlice, providerUserReadSlice, providerUserUpdateSlice, providerUserDeleteSlice, productShortListSlice, productFullListSlice, productCartListSlice, productCartCreateSlice, productCartReadSlice, productCartDeleteSlice, accountProductShortListSlice, accountProductFullListSlice, accountProductCartListSlice, accountProductCartCreateSlice, accountProductCartReadSlice, accountProductCartDeleteSlice, accountProviderUserListSlice, accountProviderUserCreateSlice, accountProviderUserReadSlice, accountProviderUserUpdateSlice, accountProviderUserDeleteSlice, accountProviderUserHealthCheckSlice, sourceApplicationSlice, applicationUserRelationListSlice, applicationUserRelationCreateSlice, applicationUserRelationReadSlice, applicationUserRelationDeleteSlice, accountClientContactListSlice, accountClientContactCreateSlice, accountClientContactReadSlice, accountClientContactUpdateSlice, accountClientContactDeleteSlice, accountClientListSlice, accountClientCreateSlice, accountClientReadSlice, accountClientUpdateSlice, accountClientDeleteSlice, accountProductCartListDeleteSlice, accountProductOrderListSlice, accountProductOrderReadSlice, accountProductOrderCreateSlice, toastSlice, providerParserFileListSlice, providerParserFileDeleteSlice, providerParserFileUpdateSlice, providerBrandCreateSlice, providerBrandDeleteSlice } from './slices';


// const middlewares: Array<unknown> = [];
// const reducersNum: Record<string, unknown> = {};
// Object.values(reducers).forEach(item => {
// 	reducersNum[item.reducerPath] = item.reducer;
// 	middlewares.push(item.middleware);
// });

// const reducer = combineReducers({});

// return getDefaultMiddleware().concat(...middlewares);

// const reducer = {};

// for (const k in slices) {
// 	const item = slices[k];

// }

// const arr = Object.values(slices);

// for (let i = 0; i < arr.length; i++) {
// 	const item = arr[i];
// 	reducer[item.name] = item.reducer;
// }

// const reducer = combineReducers({
// 	[SLICE_PUBLIC_CVS]: publicCvsSlice.reducer,
// 	[SLICE_PUBLIC_CV]: publicCvSlice.reducer,
// 	[SLICE_SIGN_IN]: signInSlice.reducer,
// 	[SLICE_AUTH_RECOVERY]: recoverySlice.reducer,
// 	[SLICE_CREDENTIALS]: accountSlice.reducer,
// });

// const reducers = combineReducers({
	// [publicCvApi.reducerPath]: publicCvApi.reducer,
	// [signInApi.reducerPath]: signInApi.reducer,
// });

export const store = configureStore({
	reducer: {
		[signUpSlice.name]: signUpSlice.reducer,
		[signInSlice.name]: signInSlice.reducer,
		[signOutSlice.name]: signOutSlice.reducer,

		[recoverySlice.name]: recoverySlice.reducer,

		[accountCredentialsSlice.name]: accountCredentialsSlice.reducer,
		[accountPasswordSlice.name]: accountPasswordSlice.reducer,

		[accountReadSlice.name]: accountReadSlice.reducer,
		[accountUpdateSlice.name]: accountUpdateSlice.reducer,

		[accountPassportReadSlice.name]: accountPassportReadSlice.reducer,
		[accountPassportUpdateSlice.name]: accountPassportUpdateSlice.reducer,

		[accountCardReadSlice.name]: accountCardReadSlice.reducer,

		[accountPhoneNumberReadSlice.name]: accountPhoneNumberReadSlice.reducer,
		[accountPhoneNumberUpdateSlice.name]: accountPhoneNumberUpdateSlice.reducer,
		[accountPhoneNumberUpdateConfirmSlice.name]: accountPhoneNumberUpdateConfirmSlice.reducer,

		[accountEmailReadSlice.name]: accountEmailReadSlice.reducer,
		[accountEmailUpdateSlice.name]: accountEmailUpdateSlice.reducer,
		[accountEmailUpdateConfirmSlice.name]: accountEmailUpdateConfirmSlice.reducer,

		[accountTypeChangesSlice.name]: accountTypeChangesSlice.reducer,
		[accountTypeChangeReadSlice.name]: accountTypeChangeReadSlice.reducer,

		[accountProductShortListSlice.name]: accountProductShortListSlice.reducer,
		[accountProductFullListSlice.name]: accountProductFullListSlice.reducer,

		[accountProductCartListSlice.name]: accountProductCartListSlice.reducer,
		[accountProductCartListDeleteSlice.name]: accountProductCartListDeleteSlice.reducer,
		[accountProductCartCreateSlice.name]: accountProductCartCreateSlice.reducer,
		[accountProductCartReadSlice.name]: accountProductCartReadSlice.reducer,
		[accountProductCartDeleteSlice.name]: accountProductCartDeleteSlice.reducer,

		[accountProductOrderListSlice.name]: accountProductOrderListSlice.reducer,
		[accountProductOrderCreateSlice.name]: accountProductOrderCreateSlice.reducer,
		[accountProductOrderReadSlice.name]: accountProductOrderReadSlice.reducer,

		[accountProviderUserListSlice.name]: accountProviderUserListSlice.reducer,
		[accountProviderUserCreateSlice.name]: accountProviderUserCreateSlice.reducer,
		[accountProviderUserReadSlice.name]: accountProviderUserReadSlice.reducer,
		[accountProviderUserUpdateSlice.name]: accountProviderUserUpdateSlice.reducer,
		[accountProviderUserDeleteSlice.name]: accountProviderUserDeleteSlice.reducer,

		[accountProviderUserHealthCheckSlice.name]: accountProviderUserHealthCheckSlice.reducer,

		[accountClientListSlice.name]: accountClientListSlice.reducer,
		[accountClientCreateSlice.name]: accountClientCreateSlice.reducer,
		[accountClientReadSlice.name]: accountClientReadSlice.reducer,
		[accountClientUpdateSlice.name]: accountClientUpdateSlice.reducer,
		[accountClientDeleteSlice.name]: accountClientDeleteSlice.reducer,

		[accountClientContactListSlice.name]: accountClientContactListSlice.reducer,
		[accountClientContactCreateSlice.name]: accountClientContactCreateSlice.reducer,
		[accountClientContactReadSlice.name]: accountClientContactReadSlice.reducer,
		[accountClientContactUpdateSlice.name]: accountClientContactUpdateSlice.reducer,
		[accountClientContactDeleteSlice.name]: accountClientContactDeleteSlice.reducer,

		[sourceAccountClientSlice.name]: sourceAccountClientSlice.reducer,

		[usersSlice.name]: usersSlice.reducer,
		[userCreateSlice.name]: userCreateSlice.reducer,
		[userReadSlice.name]: userReadSlice.reducer,
		[userUpdateSlice.name]: userUpdateSlice.reducer,
		[userDeleteSlice.name]: userDeleteSlice.reducer,

		[userCardReadSlice.name]: userCardReadSlice.reducer,

		[usersMetaSlice.name]: usersMetaSlice.reducer,

		[userRolesReadSlice.name]: userRolesReadSlice.reducer,

		[userPassportReadSlice.name]: userPassportReadSlice.reducer,
		[userPassportUpdateSlice.name]: userPassportUpdateSlice.reducer,

		[userPasswordReadSlice.name]: userPasswordReadSlice.reducer,
		[userPasswordUpdateSlice.name]: userPasswordUpdateSlice.reducer,

		[userPhoneNumberReadSlice.name]: userPhoneNumberReadSlice.reducer,
		[userPhoneNumberUpdateSlice.name]: userPhoneNumberUpdateSlice.reducer,
		[userPhoneNumberDeleteSlice.name]: userPhoneNumberDeleteSlice.reducer,

		[userEmailReadSlice.name]: userEmailReadSlice.reducer,
		[userEmailUpdateSlice.name]: userEmailUpdateSlice.reducer,
		[userEmailDeleteSlice.name]: userEmailDeleteSlice.reducer,

		[usersTypesSlice.name]: usersTypesSlice.reducer,
		[userTypeCreateSlice.name]: userTypeCreateSlice.reducer,
		[userTypeReadSlice.name]: userTypeReadSlice.reducer,
		[userTypeUpdateSlice.name]: userTypeUpdateSlice.reducer,
		[userTypeDeleteSlice.name]: userTypeDeleteSlice.reducer,

		[userTypeRolesReadSlice.name]: userTypeRolesReadSlice.reducer,
		[userTypeRolesUpdateSlice.name]: userTypeRolesUpdateSlice.reducer,

		[applicationListSlice.name]: applicationListSlice.reducer,
		[applicationCreateSlice.name]: applicationCreateSlice.reducer,
		[applicationReadSlice.name]: applicationReadSlice.reducer,
		[applicationUpdateSlice.name]: applicationUpdateSlice.reducer,
		[applicationDeleteSlice.name]: applicationDeleteSlice.reducer,

		[brandListSlice.name]: brandListSlice.reducer,
		[brandCreateSlice.name]: brandCreateSlice.reducer,
		[brandReadSlice.name]: brandReadSlice.reducer,
		[brandUpdateSlice.name]: brandUpdateSlice.reducer,
		[brandDeleteSlice.name]: brandDeleteSlice.reducer,

		[providerListSlice.name]: providerListSlice.reducer,
		[providerCreateSlice.name]: providerCreateSlice.reducer,
		[providerReadSlice.name]: providerReadSlice.reducer,
		[providerUpdateSlice.name]: providerUpdateSlice.reducer,
		[providerDeleteSlice.name]: providerDeleteSlice.reducer,

		[providerBrandListSlice.name]: providerBrandListSlice.reducer,
		[providerBrandCreateSlice.name]: providerBrandCreateSlice.reducer,
		[providerBrandReadSlice.name]: providerBrandReadSlice.reducer,
		[providerBrandUpdateSlice.name]: providerBrandUpdateSlice.reducer,
		[providerBrandDeleteSlice.name]: providerBrandDeleteSlice.reducer,

		[providerUserListSlice.name]: providerUserListSlice.reducer,
		[providerUserCreateSlice.name]: providerUserCreateSlice.reducer,
		[providerUserReadSlice.name]: providerUserReadSlice.reducer,
		[providerUserUpdateSlice.name]: providerUserUpdateSlice.reducer,
		[providerUserDeleteSlice.name]: providerUserDeleteSlice.reducer,

		[providerParserFileListSlice.name]: providerParserFileListSlice.reducer,
		[providerParserFileUpdateSlice.name]: providerParserFileUpdateSlice.reducer,
		[providerParserFileDeleteSlice.name]: providerParserFileDeleteSlice.reducer,

		[applicationUserRelationListSlice.name]: applicationUserRelationListSlice.reducer,
		[applicationUserRelationCreateSlice.name]: applicationUserRelationCreateSlice.reducer,
		[applicationUserRelationReadSlice.name]: applicationUserRelationReadSlice.reducer,
		[applicationUserRelationDeleteSlice.name]: applicationUserRelationDeleteSlice.reducer,

		[sourceProviderSlice.name]: sourceProviderSlice.reducer,
		[sourceBrandSlice.name]: sourceBrandSlice.reducer,
		[sourceApplicationSlice.name]: sourceApplicationSlice.reducer,

		[productShortListSlice.name]: productShortListSlice.reducer,
		[productFullListSlice.name]: productFullListSlice.reducer,

		[productCartListSlice.name]: productCartListSlice.reducer,
		[productCartCreateSlice.name]: productCartCreateSlice.reducer,
		[productCartReadSlice.name]: productCartReadSlice.reducer,
		[productCartDeleteSlice.name]: productCartDeleteSlice.reducer,

		[usersTypeHistoriesSlice.name]: usersTypeHistoriesSlice.reducer,
		[userTypeHistoryReadSlice.name]: userTypeHistoryReadSlice.reducer,
		[userTypeHistoryUpdateSlice.name]: userTypeHistoryUpdateSlice.reducer,

		[userClientListSlice.name]: userClientListSlice.reducer,
		[userClientCreateSlice.name]: userClientCreateSlice.reducer,
		[userClientReadSlice.name]: userClientReadSlice.reducer,
		[userClientUpdateSlice.name]: userClientUpdateSlice.reducer,
		[userClientDeleteSlice.name]: userClientDeleteSlice.reducer,

		[userClientContactListSlice.name]: userClientContactListSlice.reducer,
		[userClientContactCreateSlice.name]: userClientContactCreateSlice.reducer,
		[userClientContactReadSlice.name]: userClientContactReadSlice.reducer,
		[userClientContactUpdateSlice.name]: userClientContactUpdateSlice.reducer,
		[userClientContactDeleteSlice.name]: userClientContactDeleteSlice.reducer,

		[systemSettingsSlice.name]: systemSettingsSlice.reducer,
		[systemSettingReadSlice.name]: systemSettingReadSlice.reducer,
		[systemSettingUpdateSlice.name]: systemSettingUpdateSlice.reducer,

		[systemSettingTypesSlice.name]: systemSettingTypesSlice.reducer,
		[systemSettingTypeReadSlice.name]: systemSettingTypeReadSlice.reducer,
		[systemSettingTypeUpdateSlice.name]: systemSettingTypeUpdateSlice.reducer,

		[systemSettingUsersSlice.name]: systemSettingUsersSlice.reducer,
		[systemSettingUsersAccountUserTypeReadSlice.name]: systemSettingUsersAccountUserTypeReadSlice.reducer,
		[systemSettingUsersAccountUserTypeUpdateSlice.name]: systemSettingUsersAccountUserTypeUpdateSlice.reducer,

		[systemSettingShiftSlice.name]: systemSettingShiftSlice.reducer,
		[systemSettingShiftsIsNoticeUsersByShiftChangesReadSlice.name]: systemSettingShiftsIsNoticeUsersByShiftChangesReadSlice.reducer,
		[systemSettingShiftsIsNoticeUsersByShiftChangesUpdateSlice.name]: systemSettingShiftsIsNoticeUsersByShiftChangesUpdateSlice.reducer,
		[systemSettingShiftsNotCountingOverworkTimeReadSlice.name]: systemSettingShiftsNotCountingOverworkTimeReadSlice.reducer,
		[systemSettingShiftsNotCountingOverworkTimeUpdateSlice.name]: systemSettingShiftsNotCountingOverworkTimeUpdateSlice.reducer,

		[systemSettingReportSlice.name]: systemSettingReportSlice.reducer,
		[systemSettingReportsPhotoNotAttachingPenaltyReadSlice.name]: systemSettingReportsPhotoNotAttachingPenaltyReadSlice.reducer,
		[systemSettingReportsPhotoNotAttachingPenaltyUpdateSlice.name]: systemSettingReportsPhotoNotAttachingPenaltyUpdateSlice.reducer,
		[systemSettingReportsWritingDelayPenaltyReadSlice.name]: systemSettingReportsWritingDelayPenaltyReadSlice.reducer,
		[systemSettingReportsWritingDelayPenaltyUpdateSlice.name]: systemSettingReportsWritingDelayPenaltyUpdateSlice.reducer,

		[systemSettingBookkeepingSlice.name]: systemSettingBookkeepingSlice.reducer,
		[systemSettingBookkeepingBillChangesConstraintReadSlice.name]: systemSettingBookkeepingBillChangesConstraintReadSlice.reducer,
		[systemSettingBookkeepingBillChangesConstraintUpdateSlice.name]: systemSettingBookkeepingBillChangesConstraintUpdateSlice.reducer,
		[systemSettingBookkeepingWorkDayHoursCountReadSlice.name]: systemSettingBookkeepingWorkDayHoursCountReadSlice.reducer,
		[systemSettingBookkeepingWorkDayHoursCountUpdateSlice.name]: systemSettingBookkeepingWorkDayHoursCountUpdateSlice.reducer,

		[systemSettingCalendarSlice.name]: systemSettingCalendarSlice.reducer,
		[systemSettingCalendarEventColorBirthdayReadSlice.name]: systemSettingCalendarEventColorBirthdayReadSlice.reducer,
		[systemSettingCalendarEventColorBirthdayUpdateSlice.name]: systemSettingCalendarEventColorBirthdayUpdateSlice.reducer,
		[systemSettingCalendarEventColorProjectReadSlice.name]: systemSettingCalendarEventColorProjectReadSlice.reducer,
		[systemSettingCalendarEventColorProjectUpdateSlice.name]: systemSettingCalendarEventColorProjectUpdateSlice.reducer,

		[systemSettingAmocrmSlice.name]: systemSettingAmocrmSlice.reducer,
		[systemSettingAmocrmClientIdReadSlice.name]: systemSettingAmocrmClientIdReadSlice.reducer,
		[systemSettingAmocrmClientIdUpdateSlice.name]: systemSettingAmocrmClientIdUpdateSlice.reducer,
		[systemSettingAmocrmClientSecretReadSlice.name]: systemSettingAmocrmClientSecretReadSlice.reducer,
		[systemSettingAmocrmClientSecretUpdateSlice.name]: systemSettingAmocrmClientSecretUpdateSlice.reducer,

		[sourceSystemSettingCalendarEventColorsSlice.name]: sourceSystemSettingCalendarEventColorsSlice.reducer,

		[toastSlice.name]: toastSlice.reducer,
	},

	// middleware: (getDefaultMiddleware) => getDefaultMiddleware({
  //   immutableCheck: { warnAfter: 128 },
  //   serializableCheck: { warnAfter: 128 },
  // }),

	// middleware: getDefaultMiddleware => {
	// 	return getDefaultMiddleware().concat(
	// 		publicCvApi.middleware,
	// 		signInApi.middleware,
	// 		// publicCvsSlice.middleware,
	// 	);
	// },
});

// setupListeners(store.dispatch);
